// extracted by mini-css-extract-plugin
module.exports = {"container":"documentations-information_container__CGu5w","table-head":"documentations-information_table-head__3GzTv","column":"documentations-information_column__1JEhV"};